import React, { useEffect, useState } from 'react';
import FormGenerator from './FormGenerator';
import { Button } from 'react-bootstrap';
import ConfirmModal from '../modal/ConfirmModal';
import { Actions } from '../../../client/Actions';
import EditButton from '../button/EditButton';
import { useLoader } from '../loader/useLoader';
import DivBetween from '../div/DivBetween';
import { useLoaderContext } from '../loader/LoaderContext';

const Form = ({
  fields,
  id,
  qrCodeField,
  qrCodeValue,
  api,
  editApi,
  title,
  shadow,
  performReload,
  initialData,
  additional,
  withoutCancel,
  customSave,
  customCancel,
  disableCleanAfterSave,
  customClean,
  reInit,
  className,
  withoutPadding,
  readOnly,
  withToggle,
  editable,
  onInvalid,
  postSaved,
  onToggleChange,
  reverseButtons,
  saveButton,
  dictionaries,
  replaceFormData,
  withoutHeader,
  onRemoveField,
  noActions,
  formDataChanged,
  createFormDataFrom,
  postCancel,
  executeSave,
  executeCancel,
  disableInvalidAlert,
  disableLoader,
  onReadyUpdate,
  width = 6,
}) => {
  const { loader, setLoader } = useLoaderContext();

  const [hideBody, setHideBody] = useState(withToggle);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState();
  const [ready, setReady] = useState(false);
  const [alertInvalid, setAlertInvalid] = useState(false);
  const [showAllerModal, setShowAllerModal] = useState(false);
  const [loadedData, setLoadedData] = useState();

  const saveData = () => {
    if (!disableLoader && !customSave) {
      setLoader(true);
    }
    if (editMode) {
      Actions.put(editApi || api + '/' + id, formData, onSaved, undefined, setLoader);
    } else {
      if (customSave) {
        customSave(formData, onSaved);
      } else {
        Actions.post(api, formData, onSaved);
      }
    }
  };

  const handleSave = () => {
    if (!ready) {
      setAlertInvalid(true);
      if (onInvalid) {
        onInvalid();
      }
      if (!disableInvalidAlert) {
        setShowAllerModal(true);
      }
    } else {
      saveData();
    }
  };

  const onSaved = (saved) => {
    if (postSaved) {
      postSaved(saved);
    }

    if (customClean) {
      setFormData(customClean(formData));
      setAlertInvalid(false);
    } else if (!disableCleanAfterSave) {
      clearData();
    }

    if (editMode) {
      setEditMode(false);

      if (id) {
        setLoadedData(undefined);
      } else {
        reInit();
      }
    }

    if (performReload) {
      performReload();
    }

    setLoader(false);
  };

  const onCancel = () => {
    if (editMode) {
      setEditMode(false);
      reInit();
    } else {
      clearData();
    }

    if (postCancel) {
      postCancel();
    }
  };

  const clearData = () => {
    setFormData(undefined);
    setAlertInvalid(false);
  };

  useEffect(() => {
    if (formDataChanged && !readOnly) {
      formDataChanged(formData);
    }
  }, [formData]);

  useEffect(() => {
    if (createFormDataFrom) {
      setFormData(createFormDataFrom);
    }
  }, [createFormDataFrom]);

  useEffect(() => {
    if (onToggleChange) {
      onToggleChange(!hideBody);
    }

    if (hideBody && editMode) {
      onCancel();
    }
  }, [hideBody]);

  useEffect(() => {
    if (!!executeSave) {
      handleSave();
    }
  }, [executeSave]);

  useEffect(() => {
    if (!!executeCancel) {
      onCancel();
    }
  }, [executeCancel]);

  useEffect(() => {
    if (replaceFormData) {
      setFormData(replaceFormData);
    }
  }, [replaceFormData]);

  useEffect(() => {
    if (onReadyUpdate) {
      onReadyUpdate(ready);
    }
  }, [ready]);

  useEffect(() => {
    console.log('id && !loadedData');
    if (id && !loadedData) {
      setEditMode(true);
      loadById();
    }
  }, [id, loadedData]);

  function dataByIdLoaded(data) {
    setLoadedData(data);
    setLoader(false);
  }

  function loadById() {
    setLoader(true);
    Actions.get(api + '/' + id, dataByIdLoaded);
  }

  return (
    <>
      <DivBetween className={'pt-0 py-2'}>
        {title && <h5>{title}</h5>}
        {editable && !editMode && (
          <EditButton onClick={() => setEditMode(true)} value={!editMode} />
        )}
      </DivBetween>
      <div className={`${title ? 'border-top pt-3' : ''} ${className} `}>
        {(id ? loadedData : true) && (
          <FormGenerator
            fields={fields}
            formData={formData}
            initData={true}
            setFormData={setFormData}
            setReady={setReady}
            onRemoveField={onRemoveField}
            localDictionaries={dictionaries}
            alertInvalid={alertInvalid}
            initialData={initialData || loadedData}
            setLoader={setLoader}
            additional={additional}
            editMode={editable && editMode}
            readOnly={editable ? !editMode : readOnly}
          />
        )}

        {!noActions && (
          <div
            className={'d-flex justify-content-between border-top mt-3 pt-3'}
          >
            {(editable ? editMode : !readOnly) && !noActions && (
              <Button
                type="submit"
                onClick={handleSave}
                className={`Save_btn ${ready ? 'valid-btn' : 'invalid-btn'} ${withoutCancel || reverseButtons ? 'ms-auto' : ''}`}
                variant="primary"
              >
                {saveButton ? saveButton : 'Zapisz'}
              </Button>
            )}
            {!withoutCancel &&
              (editable ? editMode : !readOnly) &&
              !noActions && (
                <Button
                  className={`Reset_btn ${reverseButtons ? 'order-first' : 'ms-auto'}`}
                  variant="outline-secondary"
                  onClick={onCancel}
                >
                  Anuluj
                </Button>
              )}
          </div>
        )}

        <ConfirmModal
          title={'Nie wszystkie pola zostały uzupełnione'}
          description={'Uzupełnij wymagane pola.'}
          size={'lg'}
          show={showAllerModal}
          setShow={setShowAllerModal}
          alert
          onConfirm={() => setShowAllerModal(false)}
        />
      </div>
    </>
  );
};

export default Form;
